import Blog from "../../../resources/images/hubs/blog.png";
import CaseStudy from "../../../resources/images/hubs/case-study.png";
import PressRelease from "../../../resources/images/hubs/press-release.png";
import Video from "../../../resources/images/hubs/videos.png";
import Whitepaper from "../../../resources/images/hubs/whitepapers.png";
import Webinar from "../../../resources/images/hubs/webinar.png";

import RecognizeIcon from "../../../resources/images/navigation/recognize.svg";
import RewardIcon from "../../../resources/images/navigation/reward.svg";
import ProgramsIcon from "../../../resources/images/navigation/programs.svg";
import ConnectIcon from "../../../resources/images/navigation/connect.svg";
import CommunicateIcon from "../../../resources/images/navigation/communicate.svg";
import SurveyIcon from "../../../resources/images/navigation/survey.svg";
import SpacesIcon from "../../../resources/images/navigation/spaces.svg";
import SurveysNew from "../../../resources/images/navigation/surveys-new.svg";
import ServiceShoutouts from "../../../resources/images/navigation/service-shoutouts.svg";
import Rewards from "../../../resources/images/navigation/rewards.svg";
import LSA from "../../../resources/images/navigation/lsa.svg";

const navData = [
  {
    title: "Platform",
    links: [
      {
        label: "Recognition",
        image: RecognizeIcon,
        inPageLinks: [
          {
            label: "Service Awards & Birthdays",
            href: "/platform/employee-recognition/#service-awards-and-birthdays",
          },
          {
            label: "Peer-to-Peer Recognition",
            href: "/platform/employee-recognition/#peer-to-peer-recognition",
          },
          {
            label: "Spot Recognition & Sweeteners",
            href: "/platform/employee-recognition/#spot-recognition-and-sweeteners",
          },
        ],
        href: "/platform/employee-recognition/",
        className: "motivosity",
      },
      {
        label: "Rewards",
        image: RewardIcon,
        inPageLinks: [
          {
            label: "Rewards Marketplace",
            href: "/platform/employee-rewards/marketplace",
          },
          {
            label: "Swag",
            href: "/platform/employee-rewards/marketplace/#swag",
          },
          {
            label: "ThanksMatters Card",
            href: "/platform/employee-rewards/marketplace/#thanksmatters-card",
          },
        ],
        href: "/platform/employee-rewards/",
        className: "motivosity",
      },
      {
        label: "Programs",
        image: ProgramsIcon,
        inPageLinks: [
          {
            label: "Events & Resources",
            href: "/platform/employee-programs/#events-and-resources",
          },
          {
            label: "Challenges & Nominations",
            href: "/platform/employee-programs/#challenges-and-nominations",
          },
          {
            label: "Funding & Budgets",
            href: "/platform/employee-programs/#funding-and-budgets",
          },
        ],
        href: "/platform/employee-programs/",
        className: "motivosity",
      },
      {
        label: "Connection",
        image: ConnectIcon,
        inPageLinks: [
          {
            label: "Social Feed & Profiles",
            href: "/platform/company-culture/#social-feed-and-profiles",
          },
          {
            label: "Company Directory/Org Chart",
            href: "/platform/company-culture/#company-directory-org-chart",
          },
          {
            label: "Personality Profiles",
            href: "/platform/company-culture/#social-feed-and-profiles",
          },
        ],
        href: "/platform/company-culture/",
        className: "motivosity",
      },
      {
        label: "Communication",
        image: CommunicateIcon,
        inPageLinks: [
          {
            label: "Announcements & Highlights",
            href: "/platform/employee-communication/#announcements-and-highlights",
          },
          {
            label: "Scheduling & Featuring",
            href: "/platform/employee-communication/#scheduling-and-featuring",
          },
          {
            label: "Company & Employee Spaces",
            href: "/platform/employee-communication/#company-and-employee-spaces",
          },
        ],
        href: "/platform/employee-communication/",
        className: "motivosity",
      },
      {
        label: "Engagement",
        image: SurveyIcon,
        inPageLinks: [
          {
            label: "MV6 Survey (eNPS)",
            href: "/platform/employee-engagement/#mv6-survey",
          },
          {
            label: "Pulse Surveys",
            href: "/platform/employee-engagement/#pulse-surveys",
          },
          {
            label: "Engagement Insights",
            href: "/platform/employee-engagement/#engagement-insights",
          },
        ],
        href: "/platform/employee-engagement/",
        className: "motivosity",
      },
      {
        label: "Spaces",
        image: SpacesIcon,
        inPageLinks: [{ label: "", href: "" }],
        href: "/product/spaces/",
        className: "motivosity",
      },
      {
        label: "Surveys",
        image: SurveysNew,
        inPageLinks: [{ label: "", href: "" }],
        href: "/platform/employee-engagement/",
        className: "motivosity",
      },
      {
        label: "Service Shoutouts",
        image: ServiceShoutouts,
        inPageLinks: [{ label: "", href: "" }],
        href: "/service-shoutouts",
        className: "motivosity",
      },
      {
        label: "Rewards by Motivosity",
        image: Rewards,
        inPageLinks: [{ label: "", href: "" }],
        href: "/platform/employee-rewards/marketplace#swag",
        className: "motivosity",
      },
      {
        label: "Lifestyle Spending Accounts",
        image: LSA,
        inPageLinks: [{ label: "", href: "" }],
        href: "/product/lifestyle-spending-accounts/",
        className: "motivosity",
      },
    ],
  },
  {
    title: "Pricing",
    path: "/pricing/",
    links: [],
  },
  {
    title: "Company",
    path: "/about-us/",
    links: [],
  },
  {
    title: "Resources",
    links: [
      {
        label: "Blogs",
        href: "/resources/#blogs",
        image: Blog,
      },
      {
        label: "Case Study",
        href: "/resources/#casestudy",
        image: CaseStudy,
      },
      {
        label: "Press Release",
        href: "/resources/#pressreleases",
        image: PressRelease,
      },
      {
        label: "Videos",
        href: "/resources/#videos",
        image: Video,
      },
      {
        label: "White Papers",
        href: "/resources/#whitepapers",
        image: Whitepaper,
      },
      {
        label: "Webinars",
        href: "/resources/#webinars",
        image: Webinar,
      },
    ],
  },
];

export default navData;
